module.exports = __webpack_public_path__ + "static/media/(LH)_MG_5209_-_Pro-Natura_-_Moda_Masculina_-_Moda_Masculina_Infantil_-_Moda_Familia.7172b589.jpg";